import { IEntityMappingConfig } from '../entity-mapping'

export const TEST_EXECUTION_MAPPING_CONFIG: IEntityMappingConfig = {
  classType: 'TestExecution',
  jsonType: 'test-executions',
  propertyMapping: {
    completedAt: {
      transform: {
        toModel: (dateString) => dateString ? new Date(dateString) : null
      }
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/backends/entity-mapping-manager/entity-mapping-configs/test-execution-mapping-config.ts